import React from 'react';
import { calculateCost, calculateCostPerMonth } from './utils';

interface ServerPricingInfoProps {
	sizeGb: number;
}

const ServerPricingInfo: React.FC<ServerPricingInfoProps> = ({ sizeGb }) => {
	const monthlyMaxCost = calculateCostPerMonth(sizeGb);
	const hourlyPrice = calculateCost(sizeGb);

	return (
		<div style={{ marginBottom: 12, textAlign: 'right' }}>
			<div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
				Monthly max: {monthlyMaxCost.toFixed(2)}€ / month
			</div>
			<div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
				Price: {hourlyPrice.toFixed(4)}€ / hour
			</div>
			<div style={{ fontSize: 10, opacity: 0.6, marginTop: 4 }}>
				* Price does not include taxes
			</div>
		</div>
	);
};

export default ServerPricingInfo;
